import { FC, useState } from 'react'
import { Text } from 'entities/Text'
import { MenuIcon, IconContainer, DrawerInnerContainer } from './styled'
import SettingsIcon from '@mui/icons-material/Settings'
import LogoutIcon from '@mui/icons-material/Logout'
import { useThemeStore } from 'shared/store/themeSlice'
import { useAuthStore } from 'shared/store/authSlice'
import { SettingsModal } from 'widgets/SettingsModal'

export const SidebarHandlers: FC = () => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const { logOut } = useAuthStore()

  const { themeColor } = useThemeStore()

  return (
    <>
      <DrawerInnerContainer>
        <IconContainer onClick={() => setIsSettingsOpen(prevValue => !prevValue)}>
          <MenuIcon>
            <SettingsIcon style={{ color: themeColor === 'dark' ? '#fff' : 'unset' }} />
          </MenuIcon>
          <Text>Settings</Text>
        </IconContainer>
        <IconContainer onClick={logOut}>
          <MenuIcon>
            <LogoutIcon style={{ color: themeColor === 'dark' ? '#fff' : 'unset' }} />
          </MenuIcon>
          <Text>Log out</Text>
        </IconContainer>
      </DrawerInnerContainer>
      <SettingsModal
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        headerTitle='Settings'
      />
    </>
  )
}
